import { AssetLoader } from '../AssetLoader';
import { AssetLoaderContextProps, AssetLoaderProviderProps, CreateAssetLoaderProvider } from './types';

export const createAssetLoaderProvider: CreateAssetLoaderProvider = (
    assetLoader: AssetLoader,
    Context: React.Context<AssetLoaderContextProps>
) => {
    const AssetLoaderContextProvider: React.FC<AssetLoaderProviderProps> = ({ children }) => (
        <Context.Provider
            value={{
                assetLoader,
            }}
        >
            {children}
        </Context.Provider>
    );

    return AssetLoaderContextProvider;
};
